import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import React from "react";

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder="Chọn ngày"
        style={{
            height: "40px",
            padding: "0 10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "14px",
            color: "#333",
            backgroundColor: "#fff",
            width: "120px",
            textAlign: "center",
            cursor: "pointer"
        }}
        readOnly
    />
));

function Request() {
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // States quản lý phân trang và tìm kiếm Server-side
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status, setStatus] = useState("All");
    const limit = 10;
    const typingTimeoutRef = useRef(null);

    // States thống kê
    const [totalSuccess, setTotalSuccess] = useState(0);
    const [totalPending, setTotalPending] = useState(0);

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    const fetchRefunds = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/hoantra?page=${page}&limit=${limit}&search=${searched}&startDate=${startStr}&endDate=${endStr}&status=${status}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setTotalSuccess(res.data.totalSuccess || 0);
                setTotalPending(res.data.totalPending || 0);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    useEffect(() => {
        fetchRefunds();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched, startDate, endDate, status]);

    // Xử lý tìm kiếm Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Chuyển về trang 1 khi search
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {loading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <div className="container_set">{t("history_refund")}</div>
                            <div className="form_set">
                                <Box>
                                    <div style={{ display: "flex", gap: "15px", flexDirection: "column", width: "100%", marginBottom: "15px" }}>
                                        <div style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "flex-start", width: "100%", flexWrap: "wrap" }}>
                                            <TextField size="small" defaultValue="" onChange={handleSearchChange} placeholder={t("search")} sx={{ minWidth: "180px", "& .MuiInputBase-root": { height: "40px" } }} />
                                            
                                            <select
                                                value={status}
                                                onChange={(e) => {
                                                    setStatus(e.target.value);
                                                    setPage(1);
                                                }}
                                                style={{
                                                    height: "40px",
                                                    padding: "0 10px",
                                                    borderRadius: "4px",
                                                    border: "1px solid #ccc",
                                                    outline: "none",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    backgroundColor: "#fff",
                                                    minWidth: "150px",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <option value="All">Tất cả trạng thái</option>
                                                <option value="Pending">Chờ duyệt</option>
                                                <option value="Success">Thành công</option>
                                                <option value="Deny">Từ chối</option>
                                            </select>

                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                <span style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}>Từ:</span>
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        setPage(1);
                                                    }}
                                                    customInput={<CustomDateInput />}
                                                />
                                                <span style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}>Đến:</span>
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setEndDate(date);
                                                        setPage(1);
                                                    }}
                                                    customInput={<CustomDateInput />}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", width: "100%" }}>
                                            <Button variant="outlined" size="small" onClick={() => setDatePreset("all")} sx={{ textTransform: "none", height: "30px" }}>Tất cả ngày</Button>
                                            <Button variant="outlined" size="small" onClick={() => setDatePreset("today")} sx={{ textTransform: "none", height: "30px" }}>Hôm nay</Button>
                                            <Button variant="outlined" size="small" onClick={() => setDatePreset("yesterday")} sx={{ textTransform: "none", height: "30px" }}>Hôm qua</Button>
                                            <Button variant="outlined" size="small" onClick={() => setDatePreset("thisWeek")} sx={{ textTransform: "none", height: "30px" }}>Tuần này</Button>
                                            <Button variant="outlined" size="small" onClick={() => setDatePreset("thisMonth")} sx={{ textTransform: "none", height: "30px" }}>Tháng này</Button>
                                            <Button variant="outlined" size="small" onClick={() => setDatePreset("lastMonth")} sx={{ textTransform: "none", height: "30px" }}>Tháng trước</Button>
                                        </div>
                                    </div>

                                    <Box sx={{ display: "flex", gap: "20px", margin: "20px 0", flexWrap: "wrap", justifyContent: "center" }}>
                                        <Box sx={{ flex: 1, maxWidth: "250px", minWidth: "150px", padding: "15px", borderRadius: "8px", background: "#f8f9fa", borderLeft: "4px solid #2e7d32", boxShadow: "0 2px 4px rgba(0,0,0,0.05)", textAlign: "left" }}>
                                            <div style={{ fontSize: "11px", color: "#666", fontWeight: "bold", textTransform: "uppercase" }}>Tổng Hoàn Trả Thành Công</div>
                                            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2e7d32", marginTop: "5px" }}>{Math.floor(totalSuccess).toLocaleString("vi-VN")}</div>
                                        </Box>
                                        <Box sx={{ flex: 1, maxWidth: "250px", minWidth: "150px", padding: "15px", borderRadius: "8px", background: "#f8f9fa", borderLeft: "4px solid #ed6c02", boxShadow: "0 2px 4px rgba(0,0,0,0.05)", textAlign: "left" }}>
                                            <div style={{ fontSize: "11px", color: "#666", fontWeight: "bold", textTransform: "uppercase" }}>Tổng Hoàn Trả Chờ Duyệt</div>
                                            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#ed6c02", marginTop: "5px" }}>{Math.floor(totalPending).toLocaleString("vi-VN")}</div>
                                        </Box>
                                    </Box>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px" }}>{t("username")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>ID</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t('detail')}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("money")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("status")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("time")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {data.map((item) => (
                                                    <TableRow key={item._id}>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.username}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.iduser}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.detail}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.money.toLocaleString("vi-VN")} </TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            {item?.status_payment === "Pending" && <span className="badge warning">{item?.status_payment}</span>}
                                                            {item?.status_payment === "Success" && <span className="badge success">{item?.status_payment}</span>}
                                                            {item?.status_payment === "Deny" && <span className="badge error">{item?.status_payment}</span>}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(new Date(item?.createdAt))}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={6} align="center">{t("empty")}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </Box>
                            </div>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    pt: 3
                                }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default Request;
